export const INITIAL_STATE = {
  data: null,
  isFetching: false,
  finish: false,
  error: false,
};

export const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "REQ_CLAIM_PENDING_DETAIL":
      return { ...state, isFetching: true };
    case "REQ_CLAIM_PENDING_DETAIL_SUCCEEDED":
      return { ...state, data: action.data, finish: true, isFetching: false, error: false };
    case "REQ_CLAIM_PENDING_DETAIL_FAILED":
      return { ...state, data: action.errData, finish: true, isFetching: false, error: true };
    case "RESET_CLAIM_PENDING_DETAIL":
      return INITIAL_STATE;
    default:
      return state;
  }
};
